import Request from 'gd-request';


export default class ApiBulkActions {

    constructor() {
    }

    moveTasksToProject(taskIds, toProjectId) {
        return new Request(this, 'PUT', 'bulk/tasks/move-to-project/'+toProjectId, {
            tasks: taskIds
        });
    }

    moveProjectsToProject(projectIds, toProjectId) {
        return new Request(this, 'POST', 'bulk/projects/move', {
            projectIds      : projectIds,
            parentProjectId : toProjectId
        });
    }

    addTag(taskIds, tagId) {
        return new Request(this,'POST','bulk/tasks/tag/'+tagId,{
            tasks: taskIds
        });
    }

    removeTag(taskIds, tagId) {
        return new Request(this,'POST','bulk/tasks/untag/'+tagId,{
            tasks: taskIds
        });
    }

    removeAllTags(taskIds) {
        return new Request(this,'POST','bulk/tasks/untag-all',{
            tasks: taskIds
        });
    }

    /*changeTaskType(taskIds, taskTypeId) {
        return new Request(this,'POST','tasks/task-type',{
            taskIds: taskIds,
            taskTypeId: taskTypeId
        });
    }*/

    projectsConvert(projectIds, templateId) {
        return new Request(this,'POST','bulk/projects/convert',{
            projectIds  : projectIds,
            templateId  : templateId
        });
    }

    projectsConvertV2(params) {
        return new Request(this,'POST','bulk/projects/convert-v2',params);
    }

    deleteTasks(taskIds) {
        return new Request(this,'POST','bulk/tasks/delete',{
            taskIds: taskIds
        });
    }

    updateTasks(taskIds, params) {

        // example params
        /*const requestParams = {
            taskIds             : ["3yyZQM","1gj4JW","fzjzUP"],
            priority            : 8,
            statusId            : "8hA8DU",
            actionRequiredUserId: "KElaaH",
            assignedToUserId    : "AczQKr",
            taskTypeId          : "snX3oP",
            scheduleDate        : "2022-03-25",
            storyPoints         : null,
            estimate            : 60,
            deadline            : "2022-03-30",
            startDate           : "2022-04-05",
            endDate             : "2022-04-07",
            progress            : 50,
        }*/

        const requestParams = _.assign({taskIds}, params)

        // Update scheduleDate dependency check
        if (_.has(requestParams, 'statusId') ) {
            gd.modules.validations.updateRequestPayloadOnTaskStatusChange(requestParams)
        }
        // Update scheduleDate dependency check
        if (_.has(requestParams, 'scheduleDate') ) {
            gd.modules.validations.updateRequestPayloadOnScheduleChange(requestParams)
        }



        return new Request(this,'POST','bulk/tasks/update',requestParams);
    }

    updateTasksV2(tasksUpdatesMap) {

        // example params
        /*const tasksUpdatesMap = {
            [task_id_1]: {crmContactIds: [ID1, ID2]},
            [task_id_2]: {crmContactIds: [ID1]},
        }*/

        return new Request(this,'POST','bulk/tasks/update-v2',tasksUpdatesMap);
    }

    updateTasksTimeAllocation(tasks) {
        return new Request(this,'POST','bulk/tasks/time-allocation', {
            tasks
        });
    }

    updateTasksStatus(statusUpdates) {
        // example params
        /*const statusUpdates = {
            status1Id: [id, id, id],
            status2Id: [id,id,id]
        }*/

        const payload = {statusUpdates}

        // Update status dependency check
        gd.modules.validations.updateRequestPayloadOnTaskStatusChange(payload)

        return new Request(this,'PUT','bulk/tasks/status', payload);
    }

    updateTasksPlanning(data) {
        // example data
        /*const data = [
            {
                id: taskId,
                startDate,
                endDate,
                scheduleDate, // - optional -don't pass this key if no update
            }
        ]*/
        let payload = {data}
        gd.modules.validations.updateRequestPayloadOnTaskStartEndDateChange(payload)
        return new Request(this,'PUT','bulk/tasks/planning', payload);
    }

    updateTasksCustomField(tasks, customFieldId, newValue) {
        return new Request(this,'PUT','bulk/tasks/custom-field', {
            tasks,
            customFieldId,
            newValue,
        });
    }

    updateReminders(reminders) {

        // parser.add_argument('reminders', type=dict, action='append', required=True)
        // each reminder is object with following possible params
        // parser.add_argument('isArchived',type=inputs.boolean, required=False)
        // parser.add_argument('scheduleStatus',type=int, required=False)
        // parser.add_argument('scheduleDate',type=inputDate, required=False)
        // parser.add_argument('scheduleMoment',type=inputMoment, required=False)

        return new Request(this,'POST','bulk/reminders/update-new', {reminders})
    }

    deleteReminders(reminderIds) {
        return new Request(this,'POST','bulk/reminders/delete',{reminderIds})
    }

    updateMeetings(meetingsIds, params) {
        const requestParams = _.assign({meetingsIds}, params)
        return new Request(this,'POST','bulk/meetings/update',requestParams)
    }

    updateEvents(eventIds, params) {

        // parser.add_argument('eventIds', type=inputEncodedId, action='append', required=True)
        // parser.add_argument('assignedToUserId', type=inputEncodedId, required=False)
        // parser.add_argument('isAccomplished', type=boolean, required=False)
        // parser.add_argument('startDate', type=inputDate, required=False)
        // parser.add_argument('endDate', type=inputDate, required=False)

        const requestParams = _.assign({eventIds}, params)
        return new Request(this,'POST','bulk/events/update',requestParams)
    }
}

